import React from "react";

export const DotSvg = (props) => {
    const { color, selected } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={selected ? "16":"12" }
            height={selected ? "16":"12" }
            fill="none"
            viewBox="0 0 12 12"
        >
            <circle cx="6" cy="6" r="6" fill={color || "#E3E3E3"}></circle>
        </svg>
    )
};
